import { ChevronLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

export interface DataReconciliationPageHeaderProps {
  onBack?: () => void;
}

export function DataReconciliationPageHeader({ onBack }: DataReconciliationPageHeaderProps) {
  const { t } = useTranslation('authenticated.dataReconciliation');

  return (
    <div className="shrink-0 border-b border-border bg-background px-4 py-3">
      <div className="flex items-center gap-4">
        <Button variant="outline" size="sm" onClick={onBack} className="h-7 w-7 flex-shrink-0 p-0">
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <h1 className="text-xl font-semibold leading-none text-foreground sm:text-2xl">
          {t('title')}
        </h1>
      </div>
    </div>
  );
}
